/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import { Accordion, AccordionDetails, AccordionSummary, Box, useTheme, withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CrudTable from '../clients/details/crudTable.component';
import { enumColumn } from 'modules/common/enumTableColumn';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import classNames from 'classnames';
import { deleteVendor, getVendors, postVendor, putVendor } from 'modules/common/common.actions';
import { DELETE_VENDOR_FAILURE, GET_VENDORS_FAILURE, POST_VENDOR_FAILURE, PUT_VENDOR_FAILURE } from 'modules/common/store/types';

const styles = theme => {
  return {
    row: {
      backgroundColor: theme.palette.common.white
    },
    inputGroup: {
      display: 'inline-flex',
      justifyContent: 'space-between'
    },
    root: {
      maxWidth: 170,
      marginRight: 10
    },
    extRoot: {
      width: 115,
      marginRight: 10
    },
    primaryContactRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%'
    },
    primaryText: {
      paddingTop: 12,
      paddingRight: 5
    },
    newRow: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 1050
    }
  };
};

const VendorsTable = props => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const vendorTypes = props.vendorTypes && props.vendorTypes.length > 0 ? props.vendorTypes.filter(s => s.isActive === true) : [];

  const vendorStatuses =
    props.vendorStatuses && props.vendorStatuses.length > 0 ? props.vendorStatuses.filter(s => s.isActive === true) : [];

  const adjustedColumns = [
    {
      ...enumColumn('vendorTypeId', vendorTypes),
      header: 'Type',
      type: 'dropdown-v2',
      options: vendorTypes,
      required: false,
      size: 50,
    },
    {
      ...enumColumn('statusId', vendorStatuses),
      header: 'Type',
      type: 'dropdown-v2',
      options: vendorStatuses,
      required: false,
      size: 50,
    },
    { accessorKey: 'companyName', header: 'Company Name', type: 'text', required: false, size: 50 },
    { accessorKey: 'description', header: 'Description', type: 'text', required: true, size: 70 },
    { accessorKey: 'officePhone', header: 'Phone', type: 'text', required: true, size: 70 },
    { accessorKey: 'emailAddress', header: 'Email', type: 'text', required: true, size: 50 },
    { accessorKey: 'officeEmail', header: 'Email', type: 'text', required: true, size: 50 },
    { accessorKey: 'companyWebsite', header: 'Website', type: 'text', required: true, size: 50 }
  ];

  const updateRow = async (orgRow, newRow) => {
    setIsLoading(true);
    newRow.vendorId = orgRow.original.vendorId;
    const checkValues = {
      ...newRow
    };

    const resp = await props.putVendor(newRow.vendorId, checkValues);
    if (resp.type === PUT_VENDOR_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getVendors();
      if (getResp.type === GET_VENDORS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  const createRow = async values => {
    setIsLoading(true);
    const checkValues = {
      ...values
    };

    const resp = await props.postVendor(checkValues);
    if (resp.type === POST_VENDOR_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      const getResp = await props.getVendors();
      if (getResp.type === GET_VENDORS_FAILURE) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  const deleteRow = async rowToDelete => {
    setIsLoading(true);
    const id = rowToDelete.original.vendorId;
    const resp = await props.deleteVendor(id);
    if (resp.type === DELETE_VENDOR_FAILURE) {
      return false;
    } else {
      const getResp = await props.getVendors();
      if (getResp.type === getVendors) {
        setIsLoading(false);
        return false;
      } else {
        setIsLoading(false);
        return true;
      }
    }
  };

  return (
    <Accordion
      expanded={isOpen}
      onChange={() => {
        setIsOpen(!isOpen);
      }}
      classes={{ root: classNames(props.classes.accordionStyleContacts) }}
    >
      <AccordionSummary
        expandIcon={
          <Box color={theme.palette.secondary.main}>
            <ExpandMoreIcon color="inherit" />
          </Box>
        }
      >
        <div className={props.classes.newRow}>
          <h2>Vendors</h2>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        {!isLoading && props.vendors && (
          <div>
            <CrudTable
              editingMode={'modal'} // Can be changed to 'row' to edit inline
              columns={adjustedColumns}
              rows={props.vendors}
              updateRow={updateRow}
              createRow={createRow}
              deleteRow={deleteRow}
            />
          </div>
        )}
        {isLoading && <Spinner />}
      </AccordionDetails>
    </Accordion>
  );
};

const mapStateToProps = state => {
  const { vendorTypes, vendorStatuses } = state.enumerations.allEnums;
  const { vendors } = state.common;

  return {
    vendorTypes: vendorTypes,
    vendors: vendors,
    vendorStatuses: vendorStatuses
  };
};

export default compose(
  withStyles(styles),
  withTheme,
  connect(mapStateToProps, {
    getVendors,
    deleteVendor,
    putVendor,
    postVendor
  })
)(VendorsTable);
